import { render, staticRenderFns } from "./Phantom.vue?vue&type=template&id=e9181940"
import script from "./Phantom.vue?vue&type=script&lang=js"
export * from "./Phantom.vue?vue&type=script&lang=js"
import style0 from "./Phantom.vue?vue&type=style&index=0&id=e9181940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports